import React from 'react';

import {
    withStyles,
    Grid,
    Typography,
} from '@material-ui/core';
import PropTypes from 'prop-types';

import ICON_PLAYING_BLUE from '../../images/bg/ic_football_formation_cloth_away.png';
import ICON_PLAYING_RED from '../../images/bg/ic_football_formation_cloth_home.png';


class MPlayer extends React.Component {
    render() {
        const { classes, position, num, name } = this.props;
        let icon = position == 1 ? ICON_PLAYING_BLUE : ICON_PLAYING_RED;
        return (
            <Grid container direction='column' alignItems='center' style={{ width: 86 }}>
                <Grid container direction='column' alignItems='center' justifycontent='center' style={{
                    width: 43,
                    height: 43,
                    objectFit: 'cover',
                    backgroundSize: 'cover',
                    backgroundImage: `url(${icon})`,
                    backgroundRepeat: 'no-repeat',
                }}>
                    <Typography style={{ fontSize: 12, color: '#FFF', textAlign: 'center', fontWeight: 'bold', marginTop: 8 }}>{num}</Typography>
                </Grid>
                <Typography style={{ fontSize: 10, color: '#FFF', maxWidth: 86, textAlign: 'center' }}>{name}</Typography>
            </Grid>
        );
    }
}

MPlayer.propTypes = {
    position: PropTypes.number.isRequired,
    num: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired
}

export default withStyles((theme) => ({

}))(MPlayer);